(function (global) {
    define('LNRS/Components/TabSetMobileSlider',[
        "jquery", "underscore", "eventManager"
    ], function ($, _, eventManager) {

        function TabSetMobileSlider(scope, stateChangeMessages) {
            var self = this;
            Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

            //#region message transmitter registration
            if (stateChangeMessages.length) {
                this.$scope.on("shown.bs.tab", function () {

                    stateChangeMessages.forEach(function (eventName) {
                        window.console && console.info("TabSet raises message: \'%s\'", eventName);

                        eventManager.trigger(eventName, self);
                    });

                    return false;
                });
            }
            //#endregion

            this.selectedTab = this.$scope.find("span.selected-tab").first();
            this.arrowLeft = this.$scope.find("li.left").first();
            this.arrowRight = this.$scope.find("li.right").first();
            this.tabsListModel = [];
            this.tabsNavList = this.$scope.find(".nav").first().children();
            this.tabContent = this.$scope.find(".tab-content").first();
            this.$panelToShow = null;

            this._setupDeepLinking();

            if (window.location.hash) {
                $(window).trigger('hashchange');
            }
        }

        TabSetMobileSlider.prototype.setLinksForSlider = function (selectedItem) {
            if (!selectedItem) {
                return;
            }
            if (selectedItem.index > 0 && selectedItem.index < this.tabsListModel.length - 1) {
                this.arrowLeft.find("a").attr("href", this.tabsListModel[selectedItem.index - 1].href);
                this.arrowRight.find("a").attr("href", this.tabsListModel[selectedItem.index + 1].href);
            }
            else if (selectedItem.index === 0) {
                this.arrowLeft.find("a").attr("href", this.tabsListModel[this.tabsListModel.length - 1].href);
                if (this.tabsListModel.length === 1) {
                    this.arrowRight.find("a").attr("href", this.tabsListModel[0].href);
                } else {
                    this.arrowRight.find("a").attr("href", this.tabsListModel[selectedItem.index + 1].href);
                }
                
            } else {
                this.arrowLeft.find("a").attr("href", this.tabsListModel[selectedItem.index - 1].href);
                this.arrowRight.find("a").attr("href", this.tabsListModel[0].href);
            }
        }

        TabSetMobileSlider.prototype._setupDeepLinking = function () {
            var that = this;

            this.tabsNavList.each(function (i, li) {
                var isActive = li.classList.contains("active");
                if (isActive) {
                    this.selectedTab.text(li.firstChild.text);
                }
                this.tabsListModel.push({ index: i, href: li.firstChild.hash, title: li.firstChild.text, selected: isActive ? true : false });
            }.bind(this));

            this.setLinksForSlider(_.findWhere(this.tabsListModel, { selected: true }));

            this.$scope.on("show.bs.tab", 'a[data-toggle="tab"][href*="#tab-"]', function (e) {
                this.$paneToShow = this.tabContent.find('div[id="' + e.target.hash.substring(1) + '"]');
                var $paneToShow = this.$paneToShow;

                var transitionClass = undefined;
                if (e.target.parentNode.classList.contains("right")) {
                    transitionClass = "slideLeft";
                } else if(e.target.parentNode.classList.contains("left")) {
                    transitionClass = "slideRight";
                }
                if (transitionClass) {
                    $paneToShow.addClass(transitionClass);
                    $paneToShow.on("transitionend webkitTransitionEnd", function () {
                        $paneToShow.removeClass(transitionClass).off("transitionend webkitTransitionEnd");
                    });
                } 
            }.bind(this));

            this.$scope.on("shown.bs.tab", 'a[data-toggle="tab"][href*="#tab-"]', function (e) {
                var $li = $(e.currentTarget).parent();
                var $ul = $li.parent();
                if ($ul.hasClass("tabset-slider")) {
                    this.tabsNavList.removeClass("active").find('a[href="' + e.currentTarget.hash + '"]').parent().addClass("active");
                } 

                this.arrowLeft.removeClass("active");
                this.arrowRight.removeClass("active");

                _.each(this.tabsListModel, function (item) { item.selected = false });

                var selectedItem = _.findWhere(this.tabsListModel, { href: e.currentTarget.hash });
                selectedItem.selected = true;
                this.selectedTab.text(selectedItem.title);
                this.setLinksForSlider(selectedItem);

                var anchor = "";
                var oldHash = window.location.hash.substring(1);

                if ($(e.currentTarget).is('a[data-toggle="tab"][href*="#tab-"][data-anchorable="true"]')) {
                    anchor = $(e.currentTarget).attr("href").replace("#tab-", "");
                }

                if (anchor) {
                    window.history && window.history.pushState && window.history.pushState(null, null, "#" + anchor);
                    window.location.hash = anchor;
                } else {
                    if (oldHash && $(this).closest(".nav-tabs").find('a[data-toggle="tab"][href*="#tab-' + oldHash + '"][data-anchorable="true"]').length) {
                        window.location.hash = "";
                    }
                }
            }.bind(this));

            $(window).on("hashchange", function () {
                var hash = window.location.hash;
                if (!hash) {
                    return false;
                }
                var tabHash = hash.indexOf("gnav=") !== -1 ? hash.split("/")[0] : hash;
                var tab = that.$scope.find("a[href='#tab-" + tabHash.substring(1) + "']");
                    var headerHeight = $('.score-header').outerHeight() || 0;
                    var contentDiv = "#tab-" + tabHash.substring(1);
                if (tab.length) {
                    tab.click();
                    $('html').animate({
                        scrollTop: $(contentDiv).parent().offset().top  - headerHeight - 20
                    }, 500);
                    //$([document.documentElement, document.body]).animate({
                    //    scrollTop: 0
                    //}, 500);
                }
            });
        }

        return function initTabSetMobileDropDown(args) {
            return args.IsPageEditorEditing === true
                ? null
                : new TabSetMobileSlider(args.scope, args.StateChangeMessagesTransmitting || []);
        };
    });
})(this);
